export default {
  "withdrawApproval.title": "Withdraw Approval",
  "withdrawApproval.thead.index": "#NO",
  "withdrawApproval.thead.applyId": "ApplyId",
  "withdrawApproval.thead.userno": "UserNo",
  "withdrawApproval.thead.accountNo": "AccountNo",
  "withdrawApproval.thead.accountName": "AccountName",
  "withdrawApproval.thead.bankCode": "BankCode",
  "withdrawApproval.thead.email": "Email",
  "withdrawApproval.thead.remark": "Remark",
  "withdrawApproval.thead.amount": "Amount",
  "withdrawApproval.thead.payoutAmount": "PayoutAmount",
  "withdrawApproval.thead.applyStatusDesc": "ApplyStatus",
  "withdrawApproval.thead.payoutNum": "PayoutNum",
  "withdrawApproval.thead.ipRepeatNum": "IpRepeatNum",
  "withdrawApproval.thead.platformDesc": "Platform",
  "withdrawApproval.thead.platformId": "Withdraw Platform",
  "withdrawApproval.thead.firstName": "FirstName",
  "withdrawApproval.thead.lastName": "LastName",
  "withdrawApproval.thead.nickName": "NickName",
  "withdrawApproval.thead.document": "Document",
  "withdrawApproval.thead.source": "Source",
  "withdrawApproval.thead.createTime": "CreateTime",
  "withdrawApproval.thead.modifyTime": "ModifyTime",
  "withdrawApproval.thead.action": "Action",
  "withdrawApproval.action.details": "Details",
  "withdrawApproval.action.pass": "Pass",
  "withdrawApproval.action.reject": "Reject",
  "withdrawApproval.tooltip.copyUserNo": "Copy UserNo: {text}",
  "withdrawApproval.tooltip.userDetails": "Show User Details",
  "withdrawApproval.copySuccess": "Copy Success!",
  "withdrawApproval.confirm.content":
    "Are you sure you want to {optWords} this Withdraw?",
  "withdrawApproval.confirm.ok": "Confirm",
  "withdrawApproval.confirm.cancel": "Cancel",
  "withdrawApproval.autoRefresh":
    "Automatically refresh list after {seconds} seconds",
  "withdrawApproval.autoWithdraw": "AutoWithdraw",
  "withdrawApproval.autoWithdraw.title": "{optWords} AutoWithdraw",
  "withdrawApproval.autoWithdraw.content":
    "Are you sure you want to {optWords} AutoWithdraw?",
  "withdrawApproval.switch.open": "Open",
  "withdrawApproval.switch.close": "Close",
  "withdrawApproval.form.platformId": "Please select a platform",
};
